export default {
	name: 'Convention.Dashboard',
	path: 'convention'
}